// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dLnyq","heading":"styles_heading__paZDR","subHeading":"styles_subHeading__MN0Xn"};